import { render, staticRenderFns } from "./RbuEditionPaginatedList.vue?vue&type=template&id=1d1e5d91"
import script from "./RbuEditionPaginatedList.vue?vue&type=script&lang=js"
export * from "./RbuEditionPaginatedList.vue?vue&type=script&lang=js"
import style0 from "./RbuEditionPaginatedList.vue?vue&type=style&index=0&id=1d1e5d91&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports